import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// ScrollToTop component: scrolls window and #root to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    try {
      // scroll the window
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      // also ensure the #root container (if used for scrolling) is at top
      const root = document.getElementById("root");
      if (root) {
        // If root has its own scrolling, reset it as well
        root.scrollTop = 0;
      }
      // Send SPA page_view to Google Analytics if gtag is available
      try {
        if (typeof window !== 'undefined' && window.gtag) {
          window.gtag('config', 'G-8M0ZMDB6S3', { page_path: pathname });
        }
      } catch (e) {}
    } catch (e) {
      // ignore any errors
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
